module.exports = __webpack_public_path__ + "static/media/reviewicon.92047f71.svg";